import { render, staticRenderFns } from "./mBeian.vue?vue&type=template&id=7356fba4&scoped=true"
import script from "./mBeian.vue?vue&type=script&lang=js"
export * from "./mBeian.vue?vue&type=script&lang=js"
import style0 from "./mBeian.vue?vue&type=style&index=0&id=7356fba4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7356fba4",
  null
  
)

export default component.exports